import { render, staticRenderFns } from "./distributionSummaryTable.vue?vue&type=template&id=19e3476a&scoped=true&"
import script from "./distributionSummaryTable.vue?vue&type=script&lang=js&"
export * from "./distributionSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./distributionSummaryTable.vue?vue&type=style&index=0&id=19e3476a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e3476a",
  null
  
)

export default component.exports